<template>
<div id="">
  <v-dialog v-model="show" max-width="350" :fullscreen="isFullScreen" hide-overlay transition="dialog-bottom-transition">
    <v-card tile>
      <v-card-title class="secondary white--text">
        <v-icon dark>fa-bell</v-icon>
        <v-spacer></v-spacer>
        <h5>Notifications</h5>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeNotifications()">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-title>


      <v-list two-line class="pa-0" v-if="$store.state.notifications.notifications.length">
        <v-list-item-group v-model="selected">
          <template v-for="(item, index) in $store.getters['notifications/sorted']">
                <v-list-item :key="index"  :to="item.link ? item.link : null"   :class="item.seen ? '' : 'new_notification'">
                  <template v-slot:default="{  }">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.title"></v-list-item-title>
                      <v-list-item-subtitle v-text="item.text"></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action >
        <v-list-item-action-text>
          {{item.date_added | fromNow}}
        </v-list-item-action-text>
                        <v-icon v-if="item.seen==0" color="primary">fas fa-blank</v-icon>
                        <v-icon v-else>fa-blank</v-icon>
                    </v-list-item-action>
                  </template>
          </v-list-item>

          <v-divider v-if="index + 1 < $store.state.notifications.notifications.length" :key="'d' + index"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>

      <v-container v-else>
        <v-row style="height:400px" align="center" justify="center">
          <h4>You have no new notifications</h4></v-row>
      </v-container>
      <v-card-actions class="grey lighten-3" v-if="$store.state.notifications.notifications.length">
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="clearNotifications()">Clear</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
export default {
  name: "",
  data: () => ({
    show: false,
    selected: {}
  }),
  watch: {
    'selected': function() {
      this.closeNotifications()
    }
  },
  computed: {
    isFullScreen() {
      if (this.$store.state.app.display === 'xs' || this.$store.state.app.display === 'sm') {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.$eventBus.$on('show_notifications', this.showNotifications)
  },
  methods: {
    showNotifications() {
      this.show = true
    },
    closeNotifications() {
      this.show = false
      this.$store.dispatch('notifications/seen_all')
    },
    clearNotifications() {
      this.$store.dispatch('notifications/clear')
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
.new_notification {
    border-left: 5px solid #ff5744;
}
</style>
